import { FormattedMessage } from 'react-intl';

const AddFixing = ({ addLineSchedule }: { addLineSchedule: () => Promise<void> }) => {
  return (
    <button
      type="button"
      className="btn btn-sm btn-link btn-text-icon"
      data-e2e="scheduler-add-fixing"
      onClick={addLineSchedule}
    >
      <FormattedMessage id="accumulator.scheduler.add" />
      <i className="ms-1 icon icon-sm">add_circle</i>
    </button>
  );
};

export default AddFixing;
